<div class="home2-theme">
  <app-banner></app-banner>
  <app-services-section></app-services-section>
  <app-address-section></app-address-section>
</div>
